<h1 mat-dialog-title>File Content</h1>
<mat-dialog-content class="mat-typography" style="white-space: pre-line;">
  <pre lang="xml">{{data.text}}</pre>
</mat-dialog-content>
<mat-dialog-actions allign="end">
  <button mat-button mat-dialog-close>Cancel</button>
</mat-dialog-actions>
